import tokens from './tokens';

export const lisTheme = tokens;
export type LisTheme = typeof tokens;
